document.addEventListener("DOMContentLoaded", function(event) {
  if (window.innerWidth < 700) {
    let footerNewsletter = document.getElementById("newsletter-footer-container");
    let firstFooterBlock = document.querySelectorAll(".footer__block")[0].parentNode;
    firstFooterBlock.parentNode.insertBefore(footerNewsletter, firstFooterBlock);
  }
});

document.addEventListener('DOMContentLoaded', function(event) {
  const productRecommendations = document.querySelector('product-recommendations');
  if(productRecommendations) {   
    setTimeout(function() {
      _swat.initializeActionButtons('.collection');
    }, 1000);
  }
});

document.addEventListener("facet:update",function(event) {
  setTimeout(function() {
    _swat.initializeActionButtons('.collection');
  }, 500);
});

document.addEventListener('cart:change', function(event) {
  setTimeout(function() {
    _swat.initializeActionButtons('.cart-drawer');

    document.querySelectorAll('.cart-drawer__items [data-swaction="addToWishlist"]').forEach(cartDrawerWishlistButton => {
      cartDrawerWishlistButton.addEventListener('click', function() {
        console.log('clicked');
      });
    });
  }, 500);
});

const thumbnailDesktopControl = document.getElementById('thumbnail-desktop-control');
if (thumbnailDesktopControl !== null) {
  thumbnailDesktopControl.addEventListener('click', function() {
    let mediaId = document.querySelector('product-gallery-navigation button[aria-current="true"] + button').getAttribute('data-media-id');
    if (mediaId !== null) {
      document.querySelector('button[data-media-id="'+ mediaId +'"]').click();
    }
  });
}

document.addEventListener("DOMContentLoaded", function(event) {
  let urlParams = new URLSearchParams(window.location.search);
  let sizeParam = urlParams.get('Size');
  if (sizeParam) {
    document.querySelectorAll(".ColorSwatchList a").forEach(link => {
      var current = link.href.split('?')[0];
      var varId = link.getAttribute('data-size-' + sizeParam);
      link.href = current + '?variant=' + varId + '&Size=' + sizeParam;
    }); 
  } 
});

document.addEventListener('variant:change', function(event) {
  let selectedSize = event.detail.variant.option1.replace(/\s/g, "").replace(/\//g, "-").toLowerCase();
  console.log(selectedSize);
  document.querySelectorAll(".ColorSwatchList a").forEach(link => {
    link.classList.remove("sold-out");
    var current = link.href.split('?')[0];
    var varId = link.getAttribute('data-size-' + selectedSize);
    var varInventory = link.getAttribute('data-size-inventory-' + selectedSize);
    link.href = current + '?variant=' + varId + '&Size=' + selectedSize;
    console.log(varInventory);
    if (varInventory <= 0) {
      link.classList.add("sold-out");
    }
  });  
});

$(document).on('click', '.grid-cross-links label.ColorSwatch', function (e) {
  e.preventDefault();
  e.stopPropagation()

  if ($(this).data('swatch-product-image')) {
    let main_image = $(this).parents('.product-card').find('.product-card__image--primary');
    let alt_image = $(this).parents('.product-card').find('.product-card__image--secondary');

    var newImageElement = document.createElement('img');
    newImageElement.className = 'product-card__image product-card__image--primary  aspect-natural';
    newImageElement.setAttribute('width', '1200px');
    newImageElement.setAttribute('height', '1600px');
    newImageElement.setAttribute('src', $(this).data('swatch-product-image'));

    var newAltImageElement = document.createElement('img');
    newAltImageElement.className = 'product-card__image product-card__image--secondary  aspect-natural';
    newAltImageElement.setAttribute('src', $(this).data('swatch-product-alt-image'));
    
    $(main_image).replaceWith(newImageElement);
    $(alt_image).replaceWith(newAltImageElement);
  }
  var productItem = this.closest('.product-card');
  var variantUrl = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-url");
  var variantTitle = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-title");
  var variantPrice = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-price");
  var variantComparePrice = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-compare-price");
  var variantFullPrice = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-full-price");
  var variantAvailable = $(this).siblings('.ColorSwatch__Radio').attr("data-variant-available");
  var swatchProductQuickBuy = $(this).siblings('.ColorSwatch__Radio').attr("data-swatch-product-quickbuy");
  productItem.querySelector('input[type="radio"]:checked').checked = false;
  var newSelectedSwatches = $(this).siblings('.ColorSwatch__Radio');
  var newSelectedSwatch = newSelectedSwatches[0];
  newSelectedSwatch.checked = true;
  if (variantFullPrice == "true") {
    productItem.classList.remove("Sale");
    productItem.classList.add("Full");
  } else {
    productItem.classList.remove("Full");
    productItem.classList.add("Sale");
  }
  if (variantAvailable == "true") {
    productItem.classList.remove("Sold-Out");
    productItem.classList.add("Available");
  } else {
    productItem.classList.remove("Available");
    productItem.classList.add("Sold-Out");
  }
  productItem.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
  productItem.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
  productItem.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
  productItem.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
  productItem.querySelector('.product-card__quick-add-button').setAttribute('aria-controls', swatchProductQuickBuy);
    
});

$(document).on('click', '#sizing-info-trigger', function (e) {
  console.log('clicked');
  let sizingAccordion = document.querySelector('[accordion-type="Sizing"][aria-expanded="false"]');
  if (sizingAccordion) {
    document.querySelector('[accordion-type="Sizing"] summary').click();
  }
  if ($(window).width() < 1000) {
     document.querySelector('[accordion-type="Sizing"] summary').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }
  else {
     document.querySelector('[accordion-type="Sizing"] summary').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }
});

$(document).on('click', '#product-gallery__model-details', function (e) {
  let modelAccordion = document.querySelector('[accordion-type="Model Details"][aria-expanded="false"]');
  if (modelAccordion) {
    document.querySelector('[accordion-type="Model Details"] summary').click();
  }
  if ($(window).width() < 1000) {
     document.querySelector('[accordion-type="Model Details"] summary').scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }
  else {
     document.querySelector('[accordion-type="Model Details"] summary').scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }
});

$(document).on('click', '.swatch-products-more', function () {
  $(this).remove();
});

document.addEventListener("DOMContentLoaded", function(event) {
  var hash = window.location.hash;
  if(hash == "#sizing-info-trigger") {
    document.querySelector('#sizing-info-trigger').click();
  }

  var reviewRedeemHash = window.location.hash;
  if(hash == "#oke-loyalty-redeem") {
    setTimeout(function() {
      const t = document.querySelector("#oke-loyalty-redeem");
      t.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }, 1500); 
    setTimeout(function() {
      const t = document.querySelector("#oke-loyalty-redeem");
      t.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }, 2000);
  }
});

document.addEventListener('cart:change', function(event) {
  let cart = event.detail.cart; // Get the updated content of the cart
  console.log(cart);
  if (cart.item_count == 1 && cart.items[0].handle == "navidium-shipping-protection") {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      },
      error: function(XMLHttpRequest, textStatus) {
        /* error code */
      }
    });
    return false;
  }
});


document.addEventListener("DOMContentLoaded", function(event) {
  setTimeout(function() {
    // Define the event listener function
    let addedToCartListener = function(e) {  
      var data = e.detail.d.productData;	
      console.log("YAY! Added the product to cart", data);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.querySelector('[aria-controls="cart-drawer"]').click();
    };
    
    // Add listener for the 'addedtocart' event to the Swym Event Layer
    _swat.evtLayer.addEventListener('sw:addedtocart', addedToCartListener);

    
    // Define the event listener function
    let addedToWishlistListener = function(e) {
    	var data = e.detail.d;
    	console.log("YAY! Added the product to wishlist", data);
        // Define success callback
        let onSuccess = function(lists) {
          // Successfully fetched all lists 
          document.querySelector('.cart-drawer__items .remove[data-variant-id="' + data.epi + '"]').click();
          console.log(lists[0].cnt);
          document.querySelector('#swym-wisthlist-count span').innerText = lists[0].cnt;
          document.querySelector('#swym-wisthlist-count span').setAttribute('data-wishlist-count', lists[0].cnt);
          console.log(e);
        }
        
        // Define error callback
        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error while fetching all Lists", error);
        }
        
        // Call `fetchLists` function
        _swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });
    };
    
    // Add listener for the 'addedtowishlist' event to the Swym Event Layer
    _swat.evtLayer.addEventListener('sw:addedtowishlist', addedToWishlistListener);

    
    // Define the event listener function
    let removedFromWishlistListener = function(e) { 
      var data = e.detail.d.productData;	
      console.log("YAY! Removed the product from wishlist", data);
      // Define success callback
        let onSuccess = function(lists) {
          // Successfully fetched all lists 
          if (lists[0].cnt > 0) {
            document.querySelector('.header__secondary-nav .swym-wishlist').setAttribute('data-wishlist-found', '');
          }
        }
        
        // Define error callback
        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error while fetching all Lists", error);
        }
        
        // Call `fetchLists` function
        _swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });
    };
    
    // Add listener for the 'removedfromwishlist' event to the Swym Event Layer
    _swat.evtLayer.addEventListener('sw:removedfromwishlist', removedFromWishlistListener);

    let onSuccess = function(lists) {
      // Successfully fetched all lists 
      if (lists[0].cnt > 0) {
        document.querySelector('.header__secondary-nav .swym-wishlist').setAttribute('data-wishlist-found', '');
      }
    }
    
    // Define error callback
    let onError = function(error) {
      // Error is an xhrObject
      console.log("Error while fetching all Lists", error);
    }
    
    // Call `fetchLists` function
    _swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError
    });
  }, 1500);
});

function prefetchPage(href, priority = 'auto') {
  if (!href) return
  if (document.querySelector(`link[rel="prefetch"][href="${href}"]`)) return

  const link = document.createElement('link')
  link.rel = 'prefetch'
  link.href = href
  link.fetchPriority = priority
  link.as = 'document'
  document.head.appendChild(link)
}

function prefetchPages() {
  const prefetchLinkRegex = /^(\/|(\/(products|collections|pages|policies)\/.*))$/
  const prefetchLinks = document.querySelectorAll('a[href]')

  function handleMouseOver(event) {
    prefetchPage(event.currentTarget.href, 'high')
  }

  prefetchLinks.forEach((link) => {
    if (prefetchLinkRegex.test(link.pathname)) {
      link.removeEventListener('mouseover', handleMouseOver)
      link.addEventListener('mouseover', handleMouseOver)
    }
  })
}

document.addEventListener('DOMContentLoaded', prefetchPages)
